<template>
  <div class="instructions">
    <span class="bold"> חיבור חשבון משותף</span>
    עם שם משתמש וסיסמא:
  </div>
</template>

<script>
export default {
  name: 'DiscountInstructions',
};
</script>

<style lang="scss" scoped>
  .instructions {
    .bold {
      font-weight: bold;
    }
  }
</style>
